import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/swipez--toggle--shape.svg'
import _imports_1 from '@/assets/img/swipez--sqaure--shape.svg'
import _imports_2 from '@/assets/img/Swipez--text--logo.svg'
import _imports_3 from '@/assets/img/arrow--more.svg'
import _imports_4 from '@/assets/img/fast--icon.svg'
import _imports_5 from '@/assets/img/light--icon.svg'
import _imports_6 from '@/assets/img/planet--icon.svg'


const _hoisted_1 = { class: "mobile--menu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-layout-hflex header--wrapper" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#home",
    "aria-current": "page",
    class: "brand w-inline-block w--current"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "sign--wrapper" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "toggle--wrapper" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          loading: "lazy",
          alt: "",
          class: "sign--toggle"
        })
      ]),
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        loading: "lazy",
        alt: "",
        class: "sign--square"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "w-layout-hflex swipez--text--wrapper" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        loading: "lazy",
        alt: "Swipez logotype",
        class: "swipez--text--logo"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    "aria-label": "Close menu button",
    "data-w-id": "8976391a-d210-976d-86a3-3787b3af7718",
    href: "#",
    class: "menu--button w-inline-block"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "hamb--line is--close-1" }),
    /*#__PURE__*/_createElementVNode("div", { class: "hamb--line is--close--2" })
  ])
], -1)
const _hoisted_3 = { class: "nav is--mobile--menu" }
const _hoisted_4 = {
  "data-w-id": "8976391a-d210-976d-86a3-3787b3af7702",
  href: "#account",
  class: "nav--link w-inline-block"
}
const _hoisted_5 = {
  "data-w-id": "8976391a-d210-976d-86a3-3787b3af7705",
  href: "#features",
  class: "nav--link w-inline-block"
}
const _hoisted_6 = {
  "data-w-id": "8976391a-d210-976d-86a3-3787b3af7708",
  href: "#pricing",
  class: "nav--link w-inline-block"
}
const _hoisted_7 = {
  "data-w-id": "8976391a-d210-976d-86a3-3787b3af770b",
  href: "#faq",
  class: "nav--link w-inline-block"
}
const _hoisted_8 = {
  "data-w-id": "8976391a-d210-976d-86a3-3787b3af770e",
  href: "#contact",
  class: "nav--link w-inline-block"
}
const _hoisted_9 = { class: "cta--wrapper is--mobile--menu" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "w-layout-hflex header is--dark" }
const _hoisted_13 = { class: "w-layout-hflex header--wrapper" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "#home",
  "aria-current": "page",
  class: "brand w-inline-block w--current"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "sign--wrapper" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "toggle--wrapper" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        loading: "lazy",
        alt: "",
        class: "sign--toggle"
      })
    ]),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      loading: "lazy",
      alt: "",
      class: "sign--square"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "w-layout-hflex swipez--text--wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      loading: "lazy",
      alt: "Swipez logotype",
      class: "swipez--text--logo"
    })
  ])
], -1)
const _hoisted_15 = { class: "nav" }
const _hoisted_16 = {
  href: "#account",
  class: "nav--link w-inline-block"
}
const _hoisted_17 = {
  href: "#features",
  class: "nav--link w-inline-block"
}
const _hoisted_18 = {
  href: "#pricing",
  class: "nav--link w-inline-block"
}
const _hoisted_19 = {
  href: "#faq",
  class: "nav--link w-inline-block"
}
const _hoisted_20 = {
  href: "#contact",
  class: "nav--link w-inline-block"
}
const _hoisted_21 = { class: "cta--wrapper" }
const _hoisted_22 = ["href"]
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("a", {
  "aria-label": "Menu button",
  "data-w-id": "a8c6efb2-b7f6-afdb-7057-876b412a11f0",
  href: "#",
  class: "menu--button w-inline-block"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "hamb--line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "hamb--line" })
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "header--overlay" }, null, -1)
const _hoisted_26 = {
  "data-w-id": "72fa98d1-19f4-83d1-4385-6e838d8fa27b",
  class: "hero",
  id: "home"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  "data-w-id": "a0d3df64-731a-5edf-5c16-4707d32675b2",
  class: "hero--main--overlay"
}, null, -1)
const _hoisted_28 = { class: "hero--title--wrapper" }
const _hoisted_29 = { class: "h" }
const _hoisted_30 = { class: "hero-h-wrapper" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "w-layout-hflex more--wrapper" }, [
  /*#__PURE__*/_createElementVNode("a", {
    "aria-label": "Read more button",
    href: "#account",
    class: "more w-inline-block"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      loading: "lazy",
      alt: "",
      class: "more--icon"
    })
  ])
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "hero--img--wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "gradient--bottom" }),
  /*#__PURE__*/_createElementVNode("div", { class: "gradient--top" }),
  /*#__PURE__*/_createElementVNode("div", { class: "hero--img-overlay" }),
  /*#__PURE__*/_createElementVNode("div", {
    "data-w-id": "4fef72d0-1401-f900-0d7b-69a1c139b116",
    style: {"opacity":"0","display":"none"},
    class: "hero--img",
    "data-animation-type": "spline",
    "data-spline-url": "https://prod.spline.design/IYaDkgY9wzTQCd-a/scene.splinecode"
  }, [
    /*#__PURE__*/_createElementVNode("canvas")
  ])
], -1)
const _hoisted_35 = { class: "account" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  id: "account",
  class: "anchor"
}, null, -1)
const _hoisted_37 = { class: "w-layout-hflex global--padding" }
const _hoisted_38 = { class: "global--wrapper" }
const _hoisted_39 = { class: "block--h" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "h-line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--black" })
], -1)
const _hoisted_41 = { class: "text--chip" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "h-line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--black" })
], -1)
const _hoisted_43 = { class: "hero--title--wrapper" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["href"]
const _hoisted_47 = { class: "columns--wrapper" }
const _hoisted_48 = { class: "w-layout-hflex row--wrapper" }
const _hoisted_49 = { class: "service--item" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  loading: "lazy",
  alt: ""
}, null, -1)
const _hoisted_51 = { class: "w-layout-vflex flex-block-6" }
const _hoisted_52 = { class: "h--large is--black" }
const _hoisted_53 = { class: "h--medium black" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "v-line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--black-v" })
], -1)
const _hoisted_55 = { class: "service--item" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  loading: "lazy",
  alt: ""
}, null, -1)
const _hoisted_57 = { class: "w-layout-vflex flex-block-6" }
const _hoisted_58 = { class: "h--large is--black" }
const _hoisted_59 = { class: "h--medium black" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "h-line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--black" })
], -1)
const _hoisted_61 = { class: "w-layout-hflex row--wrapper" }
const _hoisted_62 = { class: "service--item" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  loading: "lazy",
  alt: ""
}, null, -1)
const _hoisted_64 = { class: "w-layout-vflex flex-block-6" }
const _hoisted_65 = { class: "h--large is--black" }
const _hoisted_66 = { class: "h--medium black" }
const _hoisted_67 = { class: "features" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", {
  id: "features",
  class: "anchor"
}, null, -1)
const _hoisted_69 = { class: "w-layout-hflex global--padding" }
const _hoisted_70 = { class: "global--wrapper wide" }
const _hoisted_71 = { class: "block--h" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "h-line is--white" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--right" })
], -1)
const _hoisted_73 = { class: "text--chip is--yellow" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "h-line is--white" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--right" })
], -1)
const _hoisted_75 = ["innerHTML"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "v-sep" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" }),
  /*#__PURE__*/_createElementVNode("div", { class: "w-layout-hflex flex-block-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" })
  ])
], -1)
const _hoisted_77 = { class: "feature--item" }
const _hoisted_78 = { class: "w-layout-hflex flex-block-2" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "div-block-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-block" }, "01")
], -1)
const _hoisted_80 = { class: "h--large is--white" }
const _hoisted_81 = { class: "p--medium is--feature-p" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "v-sep" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" }),
  /*#__PURE__*/_createElementVNode("div", { class: "w-layout-hflex flex-block-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" })
  ])
], -1)
const _hoisted_83 = { class: "feature--item" }
const _hoisted_84 = { class: "w-layout-hflex flex-block-2" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "div-block-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-block" }, "02")
], -1)
const _hoisted_86 = ["innerHTML"]
const _hoisted_87 = { class: "p--medium is--feature-p" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "v-sep" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" }),
  /*#__PURE__*/_createElementVNode("div", { class: "w-layout-hflex flex-block-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" })
  ])
], -1)
const _hoisted_89 = { class: "feature--item" }
const _hoisted_90 = { class: "w-layout-hflex flex-block-2" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "div-block-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-block" }, "03")
], -1)
const _hoisted_92 = { class: "h--large is--white" }
const _hoisted_93 = { class: "p--medium is--feature-p" }
const _hoisted_94 = { class: "feature--item--block" }
const _hoisted_95 = { class: "div-block-3" }
const _hoisted_96 = { class: "text-block" }
const _hoisted_97 = { class: "h--large is--white v--2" }
const _hoisted_98 = ["href"]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "div-block-4" }, null, -1)
const _hoisted_100 = { class: "pricing" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", {
  id: "pricing",
  class: "anchor"
}, null, -1)
const _hoisted_102 = { class: "w-layout-hflex global--padding" }
const _hoisted_103 = { class: "global--wrapper" }
const _hoisted_104 = { class: "block--h" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "h-line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--black" })
], -1)
const _hoisted_106 = { class: "text--chip" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "h-line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--black" })
], -1)
const _hoisted_108 = { class: "pricing--wrapper" }
const _hoisted_109 = { class: "h--large black" }
const _hoisted_110 = {
  href: "#contact",
  class: "button is--black w-inline-block"
}
const _hoisted_111 = { class: "tabs w-tabs" }
const _hoisted_112 = { class: "tabs-menu w-tab-menu" }
const _hoisted_113 = {
  "data-w-tab": "Business",
  class: "tab w-inline-block w-tab-link w--current"
}
const _hoisted_114 = {
  "data-w-tab": "Private Individuals",
  class: "tab w-inline-block w-tab-link"
}
const _hoisted_115 = {
  "data-w-tab": "Personal",
  class: "tab w-inline-block w-tab-link"
}
const _hoisted_116 = { class: "tabs-content w-tab-content" }
const _hoisted_117 = {
  "data-w-tab": "Business",
  class: "tab-pane-personal w-tab-pane w--tab-active"
}
const _hoisted_118 = { class: "pricing--table--wrapper" }
const _hoisted_119 = { class: "w-layout-hflex price--item" }
const _hoisted_120 = {
  "data-w-tab": "Private Individuals",
  class: "w-tab-pane"
}
const _hoisted_121 = { class: "pricing--table--wrapper" }
const _hoisted_122 = { class: "w-layout-hflex price--item" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", null, "1000 EUR", -1)
const _hoisted_124 = { class: "w-layout-hflex price--item" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("div", null, "75 EUR", -1)
const _hoisted_126 = { class: "w-layout-hflex price--item" }
const _hoisted_127 = { class: "w-layout-hflex price--item" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", null, "0.5%", -1)
const _hoisted_129 = { class: "w-layout-hflex price--item" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", null, "0.7%", -1)
const _hoisted_131 = { class: "w-layout-hflex price--item" }
const _hoisted_132 = { class: "w-layout-hflex price--item" }
const _hoisted_133 = { class: "w-layout-hflex price--item" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", null, "0.1%", -1)
const _hoisted_135 = { class: "w-layout-hflex price--item" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", null, "0.3%", -1)
const _hoisted_137 = {
  "data-w-tab": "Personal",
  class: "w-tab-pane"
}
const _hoisted_138 = { class: "pricing--table--wrapper" }
const _hoisted_139 = { class: "w-layout-hflex price--item" }
const _hoisted_140 = { class: "w-layout-hflex price--item" }
const _hoisted_141 = { class: "w-layout-hflex price--item" }
const _hoisted_142 = { class: "w-layout-hflex price--item" }
const _hoisted_143 = { class: "w-layout-hflex price--item" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("div", null, "10 USD", -1)
const _hoisted_145 = { class: "w-layout-hflex price--item" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", null, "1.5%", -1)
const _hoisted_147 = { class: "w-layout-hflex price--item" }
const _hoisted_148 = { class: "w-layout-hflex price--item" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("div", null, "5 EUR", -1)
const _hoisted_150 = { class: "w-layout-hflex price--item" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", null, "20 USD", -1)
const _hoisted_152 = { class: "w-layout-hflex price--item" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", null, "1.5%", -1)
const _hoisted_154 = { class: "faq" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", {
  id: "faq",
  class: "anchor"
}, null, -1)
const _hoisted_156 = { class: "w-layout-hflex global--padding" }
const _hoisted_157 = { class: "global--wrapper" }
const _hoisted_158 = { class: "block--h" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "h-line is--white" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--right" })
], -1)
const _hoisted_160 = { class: "text--chip is--yellow" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("div", { class: "h-line is--white" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--right" })
], -1)
const _hoisted_162 = ["innerHTML"]
const _hoisted_163 = { class: "faq--wrapper" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("div", { class: "v-sep" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" })
], -1)
const _hoisted_165 = { class: "faq--item" }
const _hoisted_166 = {
  "data-w-id": "760e5155-fb16-35d5-58ca-9cd55997e12d",
  class: "w-layout-hflex ac--header"
}
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "open--acc--button" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--1" })
], -1)
const _hoisted_168 = {
  style: {"width":"100%","height":"0px","display":"none"},
  class: "w-layout-hflex ac--content"
}
const _hoisted_169 = { class: "w-layout-hflex flex-block-4" }
const _hoisted_170 = { class: "p--medium" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "v-sep" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" })
], -1)
const _hoisted_172 = { class: "faq--item" }
const _hoisted_173 = {
  "data-w-id": "419f7d68-2ad8-a547-6c62-027e884bd110",
  class: "w-layout-hflex ac--header"
}
const _hoisted_174 = /*#__PURE__*/_createElementVNode("div", { class: "open--acc--button" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--1" })
], -1)
const _hoisted_175 = {
  style: {"width":"100%","height":"0px","display":"none"},
  class: "w-layout-hflex ac--content"
}
const _hoisted_176 = { class: "w-layout-hflex flex-block-4" }
const _hoisted_177 = { class: "p--medium" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("div", { class: "v-sep" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" })
], -1)
const _hoisted_179 = { class: "faq--item" }
const _hoisted_180 = {
  "data-w-id": "74d9ef66-4bfe-eb9d-5c86-5c593910a767",
  class: "w-layout-hflex ac--header"
}
const _hoisted_181 = /*#__PURE__*/_createElementVNode("div", { class: "open--acc--button" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--1" })
], -1)
const _hoisted_182 = {
  style: {"width":"100%","height":"0px","display":"none"},
  class: "w-layout-hflex ac--content"
}
const _hoisted_183 = { class: "w-layout-hflex flex-block-4" }
const _hoisted_184 = { class: "p--medium" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("div", { class: "v-sep" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" })
], -1)
const _hoisted_186 = { class: "faq--item" }
const _hoisted_187 = {
  "data-w-id": "b6314e4c-3ffa-56ed-4396-96b5460f593a",
  class: "w-layout-hflex ac--header"
}
const _hoisted_188 = /*#__PURE__*/_createElementVNode("div", { class: "open--acc--button" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--1" })
], -1)
const _hoisted_189 = {
  style: {"width":"100%","height":"0px","display":"none"},
  class: "w-layout-hflex ac--content"
}
const _hoisted_190 = { class: "w-layout-hflex flex-block-4" }
const _hoisted_191 = { class: "p--medium" }
const _hoisted_192 = /*#__PURE__*/_createElementVNode("div", { class: "v-sep" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" })
], -1)
const _hoisted_193 = { class: "faq--item" }
const _hoisted_194 = {
  "data-w-id": "181dfd99-99df-ecc6-8367-0416fe0b12cd",
  class: "w-layout-hflex ac--header"
}
const _hoisted_195 = /*#__PURE__*/_createElementVNode("div", { class: "open--acc--button" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--1" })
], -1)
const _hoisted_196 = {
  style: {"width":"100%","height":"0px","display":"none"},
  class: "w-layout-hflex ac--content"
}
const _hoisted_197 = { class: "w-layout-hflex flex-block-4" }
const _hoisted_198 = { class: "p--medium" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("div", { class: "v-sep" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" })
], -1)
const _hoisted_200 = { class: "faq--item" }
const _hoisted_201 = {
  "data-w-id": "9407adf3-6b2d-8a5d-d546-f805cb02f035",
  class: "w-layout-hflex ac--header"
}
const _hoisted_202 = /*#__PURE__*/_createElementVNode("div", { class: "open--acc--button" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "ac--line--1" })
], -1)
const _hoisted_203 = {
  style: {"width":"100%","height":"0px","display":"none"},
  class: "w-layout-hflex ac--content"
}
const _hoisted_204 = { class: "w-layout-hflex flex-block-4" }
const _hoisted_205 = { class: "p--medium" }
const _hoisted_206 = /*#__PURE__*/_createElementVNode("div", { class: "v-sep" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--white" })
], -1)

import { DefaultLayout } from "@/layout";
import { ref, computed, onMounted, watch } from "vue";
import HomeAdapterService from "./adapter/HomeAdapterService";
import Footer from "@/layout/Footer.vue";
import LocaleSwitcher from "@/locales/LocaleSwitcher.vue";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

// Импорты из Vue 3 Composition API

const { locale } = useI18n();
let adminUrl = ref("");
const curLang = ref("cz");
onMounted(async () => {
  curLang.value = localStorage.getItem("locale") || "cz";
  loadSettings();
  // const script = document.createElement("script");
  // script.src = "/webflow.js";
  // script.defer = true;
  // script.onload = () => {
  //   setTimeout(() => {
  //     if (typeof Webflow !== "undefined") {
  //       Webflow.ready();
  //       Webflow.require("ix2").init(); // Запуск анимаций
  //       console.log("✅ Webflow анимации инициализированы!");
  //     } else {
  //       console.error("❌ Webflow не найден!");
  //     }
  //   }, 1000); // Задержка 500 мс
  // };
  // document.body.appendChild(script);
});
async function loadSettings() {
  try {
    // Запрашиваем файл appWebSettings.json из папки public
    const response = await fetch("/appWebSettings.json");

    // Проверяем, что запрос успешен
    if (!response.ok) {
      throw new Error("Не удалось загрузить настройки");
    }

    // Преобразуем ответ в JSON
    const settings = await response.json();

    // Сохраняем нужные параметры в переменные
    adminUrl.value = settings.adminUrl;
  } catch (error) {
    console.error("Ошибка при загрузке настроек:", error);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DefaultLayout), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("Account")), 1)
          ]),
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("Features")), 1)
          ]),
          _createElementVNode("a", _hoisted_6, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("Pricing")), 1)
          ]),
          _createElementVNode("a", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("FAQ")), 1)
          ]),
          _createElementVNode("a", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("Contact")), 1)
          ]),
          _createVNode(LocaleSwitcher)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", {
            href: _unref(adminUrl) + 'login' + '?lng=' + _unref(locale),
            class: "button is-secondary is--mobile--menu w-inline-block"
          }, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("Log in")), 1)
          ], 8, _hoisted_10),
          _createElementVNode("a", {
            href: _unref(adminUrl) + 'signup' + '?lng=' + _unref(locale),
            class: "button is--mobile--menu w-inline-block"
          }, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("header.Sign Up")), 1)
          ], 8, _hoisted_11)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", _hoisted_16, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("Account")), 1)
            ]),
            _createElementVNode("a", _hoisted_17, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("Features")), 1)
            ]),
            _createElementVNode("a", _hoisted_18, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("Pricing")), 1)
            ]),
            _createElementVNode("a", _hoisted_19, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("FAQ")), 1)
            ]),
            _createElementVNode("a", _hoisted_20, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("Contact")), 1)
            ]),
            _createVNode(LocaleSwitcher)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("a", {
              href: _unref(adminUrl) + 'login' + '?lng=' + _unref(locale),
              class: "button is-secondary w-inline-block"
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("Log in")), 1)
            ], 8, _hoisted_22),
            _createElementVNode("a", {
              href: _unref(adminUrl) + 'signup' + '?lng=' + _unref(locale),
              class: "button w-inline-block"
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("header.Sign Up")), 1)
            ], 8, _hoisted_23)
          ]),
          _hoisted_24
        ]),
        _hoisted_25
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("h1", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", {
                class: "h--super-large",
                innerHTML: _ctx.$t('UNITED BANKING')
              }, null, 8, _hoisted_31)
            ])
          ]),
          _createElementVNode("p", {
            class: "p--large",
            innerHTML: 
            _ctx.$t('Connect your partners into unified ecosystem for rapid and secure fund flows')
          
          }, null, 8, _hoisted_32)
        ]),
        _hoisted_33,
        _hoisted_34
      ]),
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("Account")), 1),
              _hoisted_42
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("h2", {
                class: "h--large black",
                innerHTML: _ctx.$t('account.PERSONAL AND BUSINESS ACCOUNT')
              }, null, 8, _hoisted_44),
              _createElementVNode("p", {
                class: "p--large is--black",
                innerHTML: _ctx.$t('account.Manage all your financial transactions')
              }, null, 8, _hoisted_45),
              _createElementVNode("a", {
                href: _unref(adminUrl) + 'signup',
                class: "button is--black w-inline-block"
              }, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("account.Create Account")), 1)
              ], 8, _hoisted_46)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("h2", _hoisted_52, _toDisplayString(_ctx.$t("account.Fast")), 1),
                    _createElementVNode("h3", _hoisted_53, _toDisplayString(_ctx.$t("account.Fast online application and onboarding")), 1)
                  ])
                ]),
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("h2", _hoisted_58, _toDisplayString(_ctx.$t("account.Simple")), 1),
                    _createElementVNode("h3", _hoisted_59, _toDisplayString(_ctx.$t("account.Execute all banking tasks at lightspeed")), 1)
                  ])
                ])
              ]),
              _hoisted_60,
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("h2", _hoisted_65, _toDisplayString(_ctx.$t("account.Global")), 1),
                    _createElementVNode("h3", _hoisted_66, _toDisplayString(_ctx.$t("account.SEPA & SWIFT for easy fund transfers globally")), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_67, [
        _hoisted_68,
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t("Features")), 1),
              _hoisted_74
            ]),
            _createElementVNode("h2", {
              class: "h--large is--white is--center",
              innerHTML: _ctx.$t('features.UNITY AT THE CORE')
            }, null, 8, _hoisted_75),
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _hoisted_79,
                _createElementVNode("h2", _hoisted_80, _toDisplayString(_ctx.$t("account.TOP-TIER SECURITY")), 1)
              ]),
              _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.$t("account.Trust")), 1)
            ]),
            _hoisted_82,
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _hoisted_85,
                _createElementVNode("h2", {
                  class: "h--large is--white",
                  innerHTML: _ctx.$t('account.SMOOTH TRANSACTIONS')
                }, null, 8, _hoisted_86)
              ]),
              _createElementVNode("p", _hoisted_87, _toDisplayString(_ctx.$t("account.Experience")), 1)
            ]),
            _hoisted_88,
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _hoisted_91,
                _createElementVNode("h2", _hoisted_92, _toDisplayString(_ctx.$t("account.INTEGRATED ECOSYSTEM")), 1)
              ]),
              _createElementVNode("p", _hoisted_93, _toDisplayString(_ctx.$t("account.Our platform")), 1)
            ]),
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.$t("EXPLORE")), 1)
              ]),
              _createElementVNode("h2", _hoisted_97, _toDisplayString(_ctx.$t("EXPLORE A COMPLETE FINANCIAL PLATFORM POWERED BY BANK ACCOUNT")), 1),
              _createElementVNode("a", {
                href: _unref(adminUrl) + 'signup',
                class: "button w-inline-block"
              }, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("account.Create Account")), 1)
              ], 8, _hoisted_98),
              _hoisted_99
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_100, [
        _hoisted_101,
        _createElementVNode("div", _hoisted_102, [
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("div", _hoisted_104, [
              _hoisted_105,
              _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.$t("pricing.PRICING")), 1),
              _hoisted_107
            ]),
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("h2", _hoisted_109, _toDisplayString(_ctx.$t("pricing.EXPLORE OUR PRICING")), 1),
              _createElementVNode("a", _hoisted_110, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Contact Sales")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("a", _hoisted_113, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.BUSINESS")), 1)
                ]),
                _createElementVNode("a", _hoisted_114, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.PRIVATE INDIVIDUALS")), 1)
                ]),
                _createElementVNode("a", _hoisted_115, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.PERSONAL")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("div", _hoisted_117, [
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.ON REQUEST")), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("div", _hoisted_122, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Handling of documents and opening a customer account")), 1),
                      _hoisted_123
                    ]),
                    _createElementVNode("div", _hoisted_124, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Account monthly service fee")), 1),
                      _hoisted_125
                    ]),
                    _createElementVNode("div", _hoisted_126, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Incoming internal payment")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Free of change")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_127, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Incoming SEPA-payment")), 1),
                      _hoisted_128
                    ]),
                    _createElementVNode("div", _hoisted_129, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Incoming SWIFT-payment")), 1),
                      _hoisted_130
                    ]),
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Internal outgoing payment between own accounts with in Swipez")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Free of change")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_132, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Internal outgoing payment with in Swipez")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Free of change")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_133, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Outgoing SEPA-payment")), 1),
                      _hoisted_134
                    ]),
                    _createElementVNode("div", _hoisted_135, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Outgoing SWIFT-payment")), 1),
                      _hoisted_136
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_137, [
                  _createElementVNode("div", _hoisted_138, [
                    _createElementVNode("div", _hoisted_139, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Opening a customer account")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Free of change")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_140, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Account monthly service fee")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Free of change")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_141, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Incoming internal payment")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Free of change")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_142, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Incoming SEPA-payment")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Free of change")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_143, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Incoming SWIFT-payment")), 1),
                      _hoisted_144
                    ]),
                    _createElementVNode("div", _hoisted_145, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Payment card top-up")), 1),
                      _hoisted_146
                    ]),
                    _createElementVNode("div", _hoisted_147, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Internal outgoing payment")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Free of change")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_148, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Outgoing SEPA-payment")), 1),
                      _hoisted_149
                    ]),
                    _createElementVNode("div", _hoisted_150, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Outgoing SWIFT-payment")), 1),
                      _hoisted_151
                    ]),
                    _createElementVNode("div", _hoisted_152, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("pricing.Withdrawal to card")), 1),
                      _hoisted_153
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_154, [
        _hoisted_155,
        _createElementVNode("div", _hoisted_156, [
          _createElementVNode("div", _hoisted_157, [
            _createElementVNode("div", _hoisted_158, [
              _hoisted_159,
              _createElementVNode("div", _hoisted_160, _toDisplayString(_ctx.$t("questtions.FAQ")), 1),
              _hoisted_161
            ]),
            _createElementVNode("h2", {
              class: "h--large is--white is--center",
              innerHTML: _ctx.$t('questtions.FREQUENTLY ASKED QUESTIONS')
            }, null, 8, _hoisted_162),
            _createElementVNode("div", _hoisted_163, [
              _hoisted_164,
              _createElementVNode("div", _hoisted_165, [
                _createElementVNode("div", _hoisted_166, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("questtions.What country is Swipez registered at?")), 1),
                  _hoisted_167
                ]),
                _createElementVNode("div", _hoisted_168, [
                  _createElementVNode("div", _hoisted_169, [
                    _createElementVNode("div", _hoisted_170, _toDisplayString(_ctx.$t("questtions.Swipez company is registered in the Czech Republic")), 1)
                  ])
                ])
              ]),
              _hoisted_171,
              _createElementVNode("div", _hoisted_172, [
                _createElementVNode("div", _hoisted_173, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("questtions.How safe is Swipez service?")), 1),
                  _hoisted_174
                ]),
                _createElementVNode("div", _hoisted_175, [
                  _createElementVNode("div", _hoisted_176, [
                    _createElementVNode("div", _hoisted_177, _toDisplayString(_ctx.$t(
                        "questtions.We use technologies that guarantee secure online payments and two-factor authentication"
                      )), 1)
                  ])
                ])
              ]),
              _hoisted_178,
              _createElementVNode("div", _hoisted_179, [
                _createElementVNode("div", _hoisted_180, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("questtions.How safe is it to keep money at Swipez?")), 1),
                  _hoisted_181
                ]),
                _createElementVNode("div", _hoisted_182, [
                  _createElementVNode("div", _hoisted_183, [
                    _createElementVNode("div", _hoisted_184, _toDisplayString(_ctx.$t(
                        "questtions.Funds of our customers are kept in a separate account in the Czech bank"
                      )), 1)
                  ])
                ])
              ]),
              _hoisted_185,
              _createElementVNode("div", _hoisted_186, [
                _createElementVNode("div", _hoisted_187, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("questtions.What documents must be presented for opening an account?")), 1),
                  _hoisted_188
                ]),
                _createElementVNode("div", _hoisted_189, [
                  _createElementVNode("div", _hoisted_190, [
                    _createElementVNode("div", _hoisted_191, _toDisplayString(_ctx.$t("questtions.When opening an account, a passport or ID card is required")), 1)
                  ])
                ])
              ]),
              _hoisted_192,
              _createElementVNode("div", _hoisted_193, [
                _createElementVNode("div", _hoisted_194, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("questtions.When will I get access to the online bank?")), 1),
                  _hoisted_195
                ]),
                _createElementVNode("div", _hoisted_196, [
                  _createElementVNode("div", _hoisted_197, [
                    _createElementVNode("div", _hoisted_198, _toDisplayString(_ctx.$t(
                        "questtions.You will get access as soon as your identity is checked and verified"
                      )), 1)
                  ])
                ])
              ]),
              _hoisted_199,
              _createElementVNode("div", _hoisted_200, [
                _createElementVNode("div", _hoisted_201, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("questtions.Residents of what countries may not open an account?")), 1),
                  _hoisted_202
                ]),
                _createElementVNode("div", _hoisted_203, [
                  _createElementVNode("div", _hoisted_204, [
                    _createElementVNode("div", _hoisted_205, _toDisplayString(_ctx.$t("questtions.Currently, an account may be opened")), 1)
                  ])
                ])
              ]),
              _hoisted_206
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})